import i18n from 'i18next';
import PhraseInContextEditorPostProcessor from 'i18next-phrase-in-context-editor-post-processor';
import { i18nResources, Language, Namespace } from 'locales';
import { initReactI18next } from 'react-i18next';

export const initI18N = () => {
  i18n
    .use(initReactI18next)
    .use(
      new PhraseInContextEditorPostProcessor({
        phraseEnabled: process.env.NX_PHRASE_ACTIVE === 'true' || false,
        projectId: process.env.NX_PHRASE_ID || '',
      }),
    )
    .init({
      resources: i18nResources,
      lng: Language.de,
      defaultNS: Namespace.default,
      fallbackNS: Namespace.default,
      keySeparator: false,
      interpolation: {
        escapeValue: false,
      },
      postProcess: ['phraseInContextEditor'],
    });

  return i18n;
};

initI18N();

export default i18n;
